import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';

/**
 * Il launcher e la campanella sono lettori della stessa porzione della coda
 * che Martina mette in evidenza nella Board (massimo dieci Stanze). Il totale
 * differito e lo storico notifiche restano consultabili, ma non gonfiano il
 * badge e non vengono spacciati per lavoro immediato.
 *
 * Poll lento: il server cache-a il count su fingerprint+TTL e la dashboard
 * live invalida questa key quando Stanze/segnali/ratings cambiano. Non
 * rieseguire il governatore ogni 10s sull'idle.
 */
export const MARTINA_OPERATIONAL_QUEUE_COUNT_QUERY_KEY = ['/api/exai/rooms/focus-count'] as const;
export const MARTINA_FOCUS_COUNT_REFETCH_INTERVAL_MS = 60_000;
export const MARTINA_FOCUS_COUNT_STALE_TIME_MS = 30_000;

export async function readMartinaOperatorNotificationCount(): Promise<number> {
  try {
    const response = await apiClient('/api/exai/rooms/focus-count', { method: 'GET' });
    const count = Number(response?.count);
    return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
  } catch (error) {
    console.warn('Coda operativa Martina non disponibile:', error);
    return 0;
  }
}

export function useMartinaOperatorNotificationCount() {
  return useQuery({
    queryKey: MARTINA_OPERATIONAL_QUEUE_COUNT_QUERY_KEY,
    queryFn: readMartinaOperatorNotificationCount,
    refetchInterval: MARTINA_FOCUS_COUNT_REFETCH_INTERVAL_MS,
    staleTime: MARTINA_FOCUS_COUNT_STALE_TIME_MS,
  });
}
